import { isApp } from "./app-type-checker.js"

export let isDebug = {
    mode(): boolean {
        return window.location.hostname.includes("local")
    },
    web(): boolean {
        return this.mode() && !isApp()
    },
    device(): boolean {
        return this.mode() && isApp()
    }
}

export let ifDebug = {
    mode(func: () => void) {
        if (isDebug.mode()) func()
    },
    web(func: () => void) {
        if (isDebug.web()) func()
    },
    device(func: () => void) {
        if (isDebug.device()) func()
    }
}

export let DEBUG = {
    defaultAutoPageTurnThreshold: <number> 2
}
